import { render, staticRenderFns } from "./CompanyListProvider.vue?vue&type=template&id=d8bd241e&scoped=true&"
import script from "./CompanyListProvider.vue?vue&type=script&lang=ts&"
export * from "./CompanyListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bd241e",
  null
  
)

export default component.exports